// extracted by mini-css-extract-plugin
module.exports = {"globalHeader":"header_globalHeader__2bP9C","logo":"header_logo__PtlWl","spaceContent":"header_spaceContent__WUV-8","spaceItem":"header_spaceItem__1b8yJ"};